module.exports = __webpack_public_path__ + "b13f2c66aa700629cb7417d4b1d7647e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/helpers/images/milestoneImage/background-green.svg
// module id = ./src/helpers/images/milestoneImage/background-green.svg
// module chunks = 5